<template>
	<div class="homePage">
		<div class=" layout shadow">
  <div class="hmylogin">
    <div class="hmy1">
      <div class="hmytext"> 注册会员</div>
      <div class="logocenttinput1">
        <input placeholder="请输入手机号码（必填）" name="mobile2" class="hmyinput"  v-model="mobile">
        <div class="logoinputA">
          <input placeholder="输入短信验证码（必填）" v-model="code" name="dxyzh" class="hmyinput">

          <input type="button" :disabled='disabled' :value="yanzhengma"  @click="sendSms()" id="send" class="lyzm">
        </div>
        <div class="logoinputA">
          <input placeholder="请输入公司名称（必填）" v-model="company" name="mobile2" class="hmyinput">
        </div>
        <div class="logoinputA">
          <input placeholder="请输入联系人姓名（必填）" v-model="nick_name" name="mobile2" class="hmyinput">
        </div>

        <!-- <div class="logoinputA">
			<el-select v-model="category_id" size="mini" placeholder="请选择投标分类（必填）" style="width:100%; line-height:45px">
				<el-option v-for="(item,index) in cascaderdata" :key="index" :label="item.name" :value="item.category_id"> </el-option>
			</el-select>
		</div> -->


        <!-- <div class="hmyf1 hptop">请上传企业资质证书(最多上传{{maxlength}}张)<em>*</em></div>

        <div id="biaodan1">

		
        <el-upload ref="upload"  action="/api/upload/image" list-type="picture-card" 
          :on-remove="imgchange" :on-preview="dialogpreview" :file-list="fileList" :limit="maxlength" 
          :class="{disabled:!isupload}" :auto-upload="true"  name="file" 
          :on-success="imgupok" :on-error="imguperr"><i class="el-icon-plus"></i>

	      </el-upload>
						
        <el-dialog :visible.sync="isdialogvisible">
          <img width="100%" :src="dialogimageurl" alt="">
        </el-dialog>

      </div> -->

        
        
        <button class="logoinputB"  @click="bindLogin()" >注册</button>

      </div>
    </div>
    
    <div class="hmy2">
		<div class="erweimas">
			<div class="erweima1"><img src="../../assets/images/65541.jpg" /></div>
			<div class="erweima2">关注官方微信公众号，及时获取招投标的最新动态！</div>
		</div>
      <p class="hmyf4">会员登录后可对招标内容进行报价！<br>
        已有账号？</p>
      <div class="hsign_btn"><router-link to="/index/login">会员登录</router-link></div>
      <div class="hreturn"><router-link to="/">查看更多招标信息</router-link></div>
    </div>
  </div>
</div>


          <div class="xiugaidizhi" v-if="xiugaist == true">
                <div class="dizhi">
                  <img id="img"  :src="pic" style="margin:0 auto; width:100%">
                  <div class="secad">
                    <input v-model="kcaptcha" placeholder="请输入验证码" />
                  </div>
                  <div class="xinzeng">
                    <div class="xinzeng1" @click="sms">
                      确定
                    </div>
                    <div class="xinzeng2" @click="quxiao">
                      取消
                    </div>
                  </div>
                </div>

              </div>
			
	</div>
</template>

<script>
	export default {
		name: "register",
		components: {},
		data() {
			return {
				company: '',
        nick_name:'',
				login: '',
				passwd: '',
				cpasswd: '',
				contact: '',
				mobile: '',
				code: '',
				disabled: false,
				yanzhengma: '获取验证码',

				pic: '',
				kcaptcha: '',
				key: '',
				duanxin: '',
				xiugaist: false,
        cascaderdata: [],
        category_id:'',

        imguparr: [],
				fileList:[],//图片列表 用于显示图片
        maxlength: 3, //最多上传几张图片
				isupload: true, //是否显示上传按钮
				isdialogvisible: false, //预览是否显示
				dialogimageurl: '', //预览图片url
        upload: [],//图
			};
		},
		created() {
			
		},
		mounted() {
			this.getreqLei()
		},
		methods: {

      async sendSms() {
				var that = this
				//验证手机
				var m = that.mobile.replace(/(^\s*)|(\s*$)/g, "");
				if (m == '' || !m) {
          this.$message.error('错了哦，手机号不能为空');
					return false;
				}
				if (that.verifymobile(m) == false) {
          this.$message.error('错了哦，手机号格式错误');
					return false;
				}
        that.captcha()
			},
      //获取图片验证码
			async captcha() {
				var that = this
				let res = await that.req.reqyanzheng({})
				
				if (res.status == 200) {
          console.log(res)
					//获取验证码成功	
					that.pic = res.data.base64
					that.key = res.data.key
					that.xiugaist = true
				}
			},



      //点击确认后发送验证码到服务器验证是否正确,获取短信验证码
			async sms() {
				var that = this
				if (that.kcaptcha == '') {
          this.$message.error('请输入验证码');
					return
				}
        var form = {
					mobile: that.mobile,
					captchaCode: that.kcaptcha,
					captchaKey: that.key,
				};

				let res = await this.req.reqSendsms({
					form
				})
				console.log('获取手机验证码')
				console.log(res)
				if (res.status == 200) {
					this.xiugaist = false
					var wait = 60;
					that.disabled = true
					var time_line = setInterval(function() {
						that.yanzhengma = (--wait) + "秒后重发"
						if (wait == -1) {
							that.yanzhengma = "重新获取"
							that.disabled = false
							clearInterval(time_line);
						}
					}, 1000);
				} else {
          this.$message.error(res.message);
				}
			},


      //注册接口
      async bindLogin() {
				var that = this
				let company = that.company.replace(/(^\s*)|(\s*$)/g, "");
				let nick_name = that.nick_name.replace(/(^\s*)|(\s*$)/g, "");
				let mobile = that.mobile.replace(/(^\s*)|(\s*$)/g, "");
				let code = that.code.replace(/(^\s*)|(\s*$)/g, "");
        		let imguparrlength = that.imguparr.length;

			
				if (mobile == '' || !mobile) {
          this.$message.error('手机号不能为空');
					return
				}
        if (that.verifymobile(mobile) == false) {
          this.$message.error('手机号格式错误');
					return false;
				}	
				if (code == '' || !code) {
          this.$message.error('请输入验证码');
					return
				}
        if (company == '' || !company) {
          this.$message.error('企业名不能为空');
					return
				}
				if (nick_name == '' || !nick_name) {
					this.$message.error('姓名不能为空');
					return
				}
        // if (that.category_id == '') {
		// 			this.$message.error('请选择投标分类');
		// 			return
		// 		}
        // if (imguparrlength < 1) {
        //   this.$message.error('请上传企业资质证书');
		// 			return
		// 		}
				
				
        let form = {
					company: that.company,
					nick_name: that.nick_name,
					mobile: that.mobile,
					smsCode: that.code,
        //   category_id:that.category_id,
        //   images: this.imguparr, 
				};	
 
							
				let res = await this.req.reqRegister({
					form
				})
				console.log(res)
				if (res.status == 200) {
					
          this.$alert('恭喜您！注册信息提交成功', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              that.$router.push({ name: 'login'})
            }
          });

				} else {
          this.$confirm('注册失败！'+res.message, '提示', {
            confirmButtonText: '确定',
            type: 'warning'
           
          });
				}
			},

      //手机号验证
			verifymobile(mobile) {
				var phone = /^13[0-9]{1}[0-9]{8}$|15[0-9]{1}[0-9]{8}$|18[0-9]{1}[0-9]{8}$|17[0-9]{9}$/;
				if (!phone.test(mobile)) {
					return false;
				}
			},
      //取消弹出框
      quxiao() {
         this.xiugaist = false
      },




      //图片change
      imgchange(file, fileList) { 
		this.fileList = fileList;  
		let zancun_imguparr = [];
		this.fileList.forEach((e) => {
			zancun_imguparr.push(e.id);
		})
		if (this.fileList.length >= this.maxlength) {
			this.isupload = false;
		} else {
			this.isupload = true;
		}
		this.imguparr = zancun_imguparr;
		console.log(this.imguparr)	
			},
      imguperr(res){
				this.$message.error(res.message);
			},
      dialogpreview(file) { //预览
				this.dialogimageurl = file.url;
				this.isdialogvisible = true;
			},
      imgupok(res){
		console.log(res)
		if(res.status == 200){
			this.imguparr.push(res.data.fileInfo.file_id);
			this.fileList.push({
				name: res.data.fileInfo.file_name,
				url: res.data.fileInfo.preview_url,
				id: res.data.fileInfo.file_id
			});
			console.log(this.imguparr)
			if (this.fileList.length >= this.maxlength) {
				this.isupload = false;
			} else {
				this.isupload = true;
			}
		}
	},

















//读取分类
			async getreqLei() {
      let res = await this.req.reqLei({
      });

      if (res.status == 200) {
        this.cascaderdata = res.data.list; 
      } else {
        this.$message.error(res.message);
      }
    },
			
		},
	};
</script>

<style lang="less" scoped>

.xiugaidizhi {
		width: 100%;
		height: 100vh;
		position: fixed;
		z-index: 10;
		left: 0;
		top: 0;
		box-sizing: border-box;
		padding: 25px;
		background-color: rgba(0, 0, 0, 0.3);
		display: flex;
		align-items: center;

		.dizhi {
			width: 300px;
			background-color: #fff;
			box-sizing: border-box;
			padding: 25px;
			border-radius: 8px;margin: 0 auto;text-align: center;

			.secad1 {
				color: #000;
				font-size: 16px;
				font-weight: bold;
				padding-bottom: 8px;
			}

			.secad {
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-sizing: border-box;
				color: #858585;
				font-size: 14px;
				line-height: 50px;
				height: 50px;
				border-bottom: 1px solid #f9f9f9;
			}

			.secad input {
				width: 100%;
				font-size: 14px;
				border: 1px solid #e8e8e8;
  padding: 10px 15px;
			}

			.xinzeng {
				padding: 25px 0 10px 0;
				width: 100%;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: space-between;
			}

			.xinzeng1 {
				height: 40px;
				width: 45%;
				line-height: 40px;
				background: linear-gradient(to right, #fd0402, #fe7879);
				text-align: center;
				color: #fff;
				font-size: 16px;
				border-radius: 5px;
			}

			.xinzeng2 {
				height: 40px;
				width: 45%;
				line-height: 40px;
				background-color: #929292;
				text-align: center;
				color: #fff;
				font-size: 16px;
				border-radius: 5px;
			}

		}
	}

 


	
	
</style>
